var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-column", class: _vm.$attrs.class }, [
    _c("div", { staticClass: "color-secondary-6 font-14" }, [
      _vm._v(" " + _vm._s(_vm.label) + " ")
    ]),
    _c("div", { staticClass: "color-black font-16" }, [
      _vm._v(" " + _vm._s(_vm.displayValue) + " ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }